import { buildPerformanceColumn } from './performance-columns';
import { formatFuncs } from './shared';

export const ColumnAuctionWonPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_IS' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionWonPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAuctionLostToBudgetPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_ISBudget' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionLostToBudgetPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAuctionLostToRankPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_ISRank' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionLostToRankPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAuctionLostToAdQualityPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_ISctr' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionLostToAdQualityPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAuctionLostToLandingPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_ISRelv' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionLostToLandingPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAuctionLostToBidPercent = ({ i18n, helpId = 'pop_BA_CampaignGrids_ISBid' }) => buildPerformanceColumn({
  i18n,
  name: 'AuctionLostToBidPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnExactMatchImpressionSharePercent = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_ExactMatchImpressionShare' }) => buildPerformanceColumn({
  i18n,
  name: 'ExactMatchImpressionSharePercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnTopImpressionSharePercent = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_TopImpressionShare' }) => buildPerformanceColumn({
  i18n,
  name: 'TopImpressionSharePercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnTopImpressionShareLostToBudget = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_TopImpressionLosttoBudget' }) => buildPerformanceColumn({
  i18n,
  name: 'TopImpressionShareLostToBudget',
  format: formatFuncs.percentage,
  property: 'PerformanceMetrics/TopISLostToBudgetPercent',
  helpId,
});

export const ColumnTopImpressionShareLostToRank = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_TopImpressionLosttoRank' }) => buildPerformanceColumn({
  i18n,
  name: 'TopImpressionShareLostToRank',
  property: 'PerformanceMetrics/TopISLostToRankPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAbsoluteTopImpressionSharePercent = ({ i18n, helpId = 'pop_BA_Reporting_ProductAds_AbsoluteTopImpShare' }) => buildPerformanceColumn({
  i18n,
  name: 'AbsoluteTopImpressionSharePercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAbsoluteTopImpressionShareLostToBudget = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoBudget' }) => buildPerformanceColumn({
  i18n,
  name: 'AbsoluteTopImpressionShareLostToBudget',
  property: 'PerformanceMetrics/AbsoluteTopISLostToBudgetPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAbsoluteTopImpressionShareLostToRank = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoRank' }) => buildPerformanceColumn({
  i18n,
  name: 'AbsoluteTopImpressionShareLostToRank',
  property: 'PerformanceMetrics/AbsoluteTopISLostToRankPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnClickSharePercent = ({ i18n, helpId = 'pop_BA_Reporting_ProductAds_ClickSharePercent' }) => buildPerformanceColumn({
  i18n,
  name: 'ClickSharePercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAudienceAuctionWonPercent = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare' }) => buildPerformanceColumn({
  i18n,
  name: 'AudienceImpressionShare',
  property: 'PerformanceMetrics/AudienceAuctionWonPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAudienceTopISLostToBudgetPercent = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostBudget' }) => buildPerformanceColumn({
  i18n,
  name: 'AudienceImpressionShareLostToBudget',
  property: 'PerformanceMetrics/AudienceTopISLostToBudgetPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnAudienceTopISLostToRankPercent = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_AudienceNetwork_ImpressionShare_LostRank' }) => buildPerformanceColumn({
  i18n,
  name: 'AudienceImpressionShareLostToRank',
  property: 'PerformanceMetrics/AudienceTopISLostToRankPercent',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnRelativeCTR = ({ i18n, helpId = 'pop_BA_Reporting_Clarity_RelativeCTR' }) => buildPerformanceColumn({
  i18n,
  name: 'RelativeCTR',
  format: formatFuncs.percentage,
  helpId,
});

export const ColumnEligibleImpressions = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'EligibleImpressions',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressions = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressions',
  helpId,
  sortable: false,
});

export const ColumnImpressionShare = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'ImpressionShare',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressionsNoBid = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressionsNoBid',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressionsSpendingCapReached = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressionsSpendingCapReached',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressionsInsufficientBid = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressionsInsufficientBid',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressionsNoTax = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressionsNoTax',
  helpId,
  sortable: false,
});

export const ColumnMissedImpressionsOther = ({ i18n, helpId }) => buildPerformanceColumn({
  i18n,
  name: 'MissedImpressionsOther',
  helpId,
  sortable: false,
});

export const competitiveColumns = [
  ColumnAuctionWonPercent,
  ColumnAuctionLostToBudgetPercent,
  ColumnAuctionLostToRankPercent,
  ColumnAuctionLostToAdQualityPercent,
  ColumnAuctionLostToLandingPercent,
  ColumnAuctionLostToBidPercent,
  ColumnClickSharePercent,
];

